import React from "react";
import "./invitationform.scss";
import BreadCrumsHeader from "../../common/BreadCrums";
import Input from "../../common/FormInputs";
import InputTextArea from "../../common/InputTextArea";
import FormLayout from "../../common/FormLayout";
import { useFormik } from "formik";
import { invitationSchema } from "../../../utils/validationSchemas";
import { sendInvite } from "../../../services/onboardingService";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";
import { toast } from "react-toastify";
import { uploadFile } from "../../../utils/s3";
import { ReactComponent as CameraIcon } from "../../../Assets/Icons/cameraIcon.svg";

const InvitaionFormPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.onboardingReducer?.loading);

  // Logo upload state
  const [logoLoading, setLogoLoading] = React.useState(false);
  const [logoUrl, setLogoUrl] = React.useState("");
  const [logoFileImage, setLogoFileImage] = React.useState(undefined);
  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      businessName: "",
      businessAddress: "",
      websiteUrl: "",
      personName: "",
      personContact: "",
      aboutBusiness: "",
      logo: "",
    },
    validationSchema: invitationSchema,
    onSubmit: async (values) => {
      try {
        console.log("invite values", values);
        const payload = {
          businessName: values?.businessName,
          address: values?.businessAddress,
          logo: logoUrl,
          website: values?.websiteUrl,
          contactPersonName: values?.personName,
          contactPersonNumber: values?.personContact,
          email: values?.email,
          category: [], // Will be empty for admin invitations
          description: values?.aboutBusiness,
        };

        const invitePromise = await dispatch(sendInvite(payload)).unwrap();

        // Debug: Log the response to see what the backend returns
        console.log("Backend response:", invitePromise);

        if (invitePromise?.success === true) {
          toast.success("Merchant invitation sent successfully!", {
            style: {
              background: "#E6F7FB",
              color: "#007EA7",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
              padding: "12px 16px",
            },
            progressStyle: {
              background: "#007EA7",
            },
            icon: "✅",
          });
          navigate("/invitation-list");
        } else {
          toast.error(invitePromise?.message || "Failed to send invitation", {
            style: {
              background: "#FEF2F2",
              color: "#DC2626",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
              padding: "12px 16px",
            },
            progressStyle: {
              background: "#DC2626",
            },
            icon: "❌",
          });
        }
      } catch (error) {
        console.error("Invitation error:", error);
        console.error("Error details:", error?.response?.data);
        console.error("Error status:", error?.response?.status);
        toast.error("Failed to send invitation. Please try again.", {
          style: {
            background: "#FEF2F2",
            color: "#DC2626",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
            padding: "12px 16px",
          },
          progressStyle: {
            background: "#DC2626",
          },
          icon: "❌",
        });
      }
    },
  });

  // Logo upload functions
  const validateImage = (data) => {
    var idxDot = data.lastIndexOf(".") + 1;
    var extFile = data.substr(idxDot, data.length).toLowerCase();
    if (
      extFile == "jpg" ||
      extFile == "jpeg" ||
      extFile == "png" ||
      extFile == "svg"
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleUploadLogo = async (event) => {
    let fileName = event.target.files[0].name;
    formik.setFieldValue("logo", fileName);
    setLogoLoading(true);
    const s3Url = await uploadFile(event.target.files[0], fileName);
    console.log("s3Url", s3Url);
    if (s3Url) {
      setLogoUrl(s3Url);
      setLogoLoading(false);
    }
    let checkValidImage = validateImage(fileName);

    if (checkValidImage) {
      let logoImageUrl = URL.createObjectURL(event.target.files[0]);
      setLogoFileImage(logoImageUrl);
      localStorage.setItem("profilePic", logoImageUrl);
    } else {
      toast.error("Only jpg/jpeg, png, and svg files are allowed!", "warning");
    }
  };

  const handleClearLogo = () => {
    formik.setFieldValue("logo", "");
    setLogoFileImage(undefined);
    setLogoUrl("");
  };

  const { firstName, lastName, email, businessName, businessAddress, websiteUrl, personName, personContact, aboutBusiness, logo } = formik.values;

  const {
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    setFieldValue,
  } = formik;

  const items = [
    {
      title: "Merchants",
    },
    {
      title: "Invitation",
    },
  ];

  const InvitationFormContent = (
    <>
      {/* TimeLine Tool */}
      <div className="mt-8 w-[100%]">
        <div className="w-[45.5%] m-auto relative">
          {/* <div className='h-[40px] flex items-center'>
                    <div className='w-[95%]' style={{ height: "1px", backgroundColor: "#C4C4C4"}}></div>
                </div>

                <div className='w-full absolute top-0 flex justify-between'>

                    <div className='flex flex-col items-center'>
                        <div className='bg-[#00ADEF] text-[20px] border-none h-[40px] w-[40px] flex justify-center items-center text-white rounded-[100%]' >1</div>
                        <p className='text-[10px] text-[#303030] font-[400] mt-2' >Invite</p>
                    </div>

                    <div className='flex flex-col items-center'>
                        <div className='bg-white text-[20px] h-[40px] w-[40px] flex justify-center items-center text-[#C4C4C4] rounded-[100%]' style={{border: '1px solid #C4C4C4'}}>2</div>
                        <p className='text-[10px] text-[#303030] font-[400] mt-2' >Send / Schedule</p>
                    </div>

                    <div className='flex flex-col items-center'>
                        <div className='bg-white text-[20px] h-[40px] w-[40px] flex justify-center items-center text-[#C4C4C4] rounded-[100%]' style={{border: '1px solid #C4C4C4'}}>3</div>
                        <p className='text-[10px] text-[#303030] font-[400] mt-2' >Complete</p>
                    </div>

                </div> */}
        </div>
      </div>

      {/* Form Inputs */}

      <div className="flex sm:flex-col md:flex-row justify-between sm:mt-0 md:mt-12 w-[100%]">
        <Input
          label="First Name"
          placeholder="Name"
          width="100%"
          radius="10px"
          InputDivClass="w-[100%]"
          name={"firstName"}
          value={firstName}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.firstName}
          touched={touched.firstName}
        />
        <div className="w-[10%]"></div>
        <Input
          label="Last Name"
          placeholder="Name"
          width="100%"
          radius="10px"
          InputDivClass="w-[100%] sm:mt-10 md:mt-0"
          name={"lastName"}
          value={lastName}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.lastName}
          touched={touched.lastName}
        />
      </div>

      <div className="flex sm:flex-col md:flex-row justify-between sm:mt-0 md:mt-12 w-[100%]">
        <Input
          label="Email"
          placeholder="Email Address"
          width="100%"
          radius="10px"
          InputDivClass="w-[100%] sm:mt-10 md:mt-0"
          name={"email"}
          value={email}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.email}
          touched={touched.email}
        />
        <div className="w-[10%]"></div>
        <Input
          label="Business Name"
          placeholder="Business Name"
          width="100%"
          radius="10px"
          InputDivClass="w-[100%] sm:mt-10 md:mt-0"
          name={"businessName"}
          value={businessName}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.businessName}
          touched={touched.businessName}
        />
      </div>

      <div className="flex sm:flex-col md:flex-row justify-between sm:mt-0 md:mt-12 w-[100%]">
        <Input
          label="Business Address"
          placeholder="Business Address"
          width="100%"
          radius="10px"
          InputDivClass="w-[100%] sm:mt-10 md:mt-0"
          name={"businessAddress"}
          value={businessAddress}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.businessAddress}
          touched={touched.businessAddress}
        />
        <div className="w-[10%]"></div>
        <Input
          label="Website URL"
          placeholder="Website URL"
          width="100%"
          radius="10px"
          InputDivClass="w-[100%] sm:mt-10 md:mt-0"
          name={"websiteUrl"}
          value={websiteUrl}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.websiteUrl}
          touched={touched.websiteUrl}
        />
      </div>

      <div className="flex sm:flex-col md:flex-row justify-between sm:mt-0 md:mt-12 w-[100%]">
        <Input
          label="Contact Person Name"
          placeholder="Contact Person Name"
          width="100%"
          radius="10px"
          InputDivClass="w-[100%] sm:mt-10 md:mt-0"
          name={"personName"}
          value={personName}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.personName}
          touched={touched.personName}
        />
        <div className="w-[10%]"></div>
        <Input
          label="Contact Person Number"
          placeholder="Contact Person Number"
          width="100%"
          radius="10px"
          InputDivClass="w-[100%] sm:mt-10 md:mt-0"
          name={"personContact"}
          value={personContact}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.personContact}
          touched={touched.personContact}
        />
      </div>

      <div className="flex sm:flex-col md:flex-row justify-between sm:mt-0 md:mt-12 w-[100%]">
        <InputTextArea
          label="Business Description"
          placeholder="Please share with us the reasons why customers should choose to visit your establishment and make purchases/ use your services"
          divClassName="relative w-[100%] sm:mt-10 md:mt-0"
          labelClassName="label-text mb-2 block"
          textareaClassName="w-full h-[150px] px-3 pt-2 rounded-[10px] bg-[#FFFFFF] border border-[#D9D9D9] text-[#303030] text-[14px] font-[400] outline-none resize-none font-poppins placeholder:text-[#8C8C8C]"
          name="aboutBusiness"
          value={aboutBusiness}
          handleBlur={handleBlur}
          error={errors.aboutBusiness}
          touched={touched.aboutBusiness}
          setFieldValue={setFieldValue}
          showCounter={false}
        />
        <div className="w-[10%]"></div>
        <div className="w-[100%]"></div>
      </div>

      {/* Logo Upload Section */}
      <div className="flex sm:flex-col md:flex-row justify-between sm:mt-0 md:mt-12 w-[100%]">
        <div className="w-[100%]">
          <label className="block text-[12px] font-[600] font-poppins text-[#303030] mb-2">Business Logo</label>
          <div className="flex items-center gap-4">
            <div
              className="relative h-[80px] w-[80px] rounded-[10px] border-2 border-solid border-[#E4E3E4] flex justify-center items-center logo cursor-pointer overflow-hidden bg-white"
              onClick={() => document.getElementById("logoFileInput")?.click()}
            >
              {logoLoading == true && <Loader />}
              {logoFileImage !== undefined ? (
                <img
                  src={logoFileImage}
                  className="w-full h-full rounded-[10px] object-cover object-center"
                  style={{ imageRendering: 'auto' }}
                  alt="Business Logo Preview"
                />
              ) : (
                <CameraIcon />
              )}
            </div>
            <input
              type="file"
              id="logoFileInput"
              hidden
              accept=".jpg,.jpeg,.png,.svg"
              onChange={handleUploadLogo}
              onClick={(event) => {
                event.target.value = null;
              }}
            />
            {logoFileImage !== undefined ? (
              <p
                className="font-poppins font-[400] text-[12px] md:text-[14px] text-[#535353] cursor-pointer"
                onClick={handleClearLogo}
              >
                Clear
              </p>
            ) : (
              <div className="flex flex-col justify-start">
                <p className="font-poppins font-[400] text-[12px] md:text-[14px] text-[#535353]">
                  Upload Business Logo <span className="text-[#8C8C8C]">(Optional)</span>
                </p>
                <p className="font-poppins font-[400] text-[10px] md:text-[12px] text-[#00adef]">
                  File type: must be an svg, jpeg, jpg, or png
                </p>
              </div>
            )}
          </div>
          {errors.logo && touched.logo && (
            <p className="text-red-500 text-[12px] mt-1">{errors.logo}</p>
          )}
        </div>
        <div className="w-[10%]"></div>
        <div className="w-[100%]"></div>
      </div>

      <div className="invite mt-16 flex justify-end w-full">
        <button
          type="submit"
          className="sendButton text-[14px] font-[400] font-poppins text-center sm:w-[35%] md:w-[30%] lg:w-[15%]"
          onClick={() => {
            handleSubmit();
          }}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send"}
        </button>
      </div>
    </>
  );

  return (
    <>
      {loading === true && <Loader />}
      <BreadCrumsHeader heading="Invitation" items={items} form={true} />
      <FormLayout title={"Let’s Invite a Merchant!"} content={InvitationFormContent} />
    </>
  );
};

export default InvitaionFormPage;
